import { FIELD_TYPES } from "constants/template-field-type";
import ThemeConfig from "segments/core-configs/theme-config";
import AssetConfig from "components/core/asset/fields-config";
import AssetAdvancedConfig from "components/core/asset/advanced-field-config";
import FullParagraphFieldsConfig from "segments/desktop/core-components/full-paragraph/fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Platform Interactive Experience",
  fields: {
    ...ThemeConfig,
    backgroundImage: {
      type: FIELD_TYPES.GALLERY,
      label: "Background Image"
    },
    glowImage: {
      type: FIELD_TYPES.NESTED,
      label: "Glow Image",
      fields: {
        src: {
          type: FIELD_TYPES.GALLERY,
          label: "Image"
        },
        width: {
          type: FIELD_TYPES.TEXT,
          label: "Width"
        },
        positionTop: {
          type: FIELD_TYPES.TEXT,
          label: "Position Top"
        },
        positionLeft: {
          type: FIELD_TYPES.TEXT,
          label: "Position Left"
        }
      }
    },
    interactions: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Interactions",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          label: {
            type: FIELD_TYPES.TEXT,
            label: "Label"
          },
          icon: {
            type: FIELD_TYPES.GALLERY,
            label: "Icon"
          },
          image: {
            type: FIELD_TYPES.NESTED,
            label: "Image",
            fields: {
              src: {
                type: FIELD_TYPES.GALLERY,
                label: "Image"
              },
              width: {
                type: FIELD_TYPES.TEXT,
                label: "Width"
              }
            }
          },
          actionAsset: {
            type: FIELD_TYPES.NESTED,
            label: "Action asset",
            fields: { ...AssetConfig, ...AssetAdvancedConfig }
          },
          position: {
            type: FIELD_TYPES.NESTED,
            label: "Position",
            fields: {
              top: {
                type: FIELD_TYPES.TEXT,
                label: "Top"
              },
              left: {
                type: FIELD_TYPES.TEXT,
                label: "Left"
              }
            }
          },
          secondaryPosition: {
            type: FIELD_TYPES.NESTED,
            label: "Secondary Position (optional)",
            fields: {
              top: {
                type: FIELD_TYPES.TEXT,
                label: "Top"
              },
              left: {
                type: FIELD_TYPES.TEXT,
                label: "Left"
              }
            }
          },
          content: {
            type: FIELD_TYPES.NESTED,
            label: "Content",
            fields: {
              ...FullParagraphFieldsConfig
            }
          }
        }
      }
    }
  }
};
